import { Redirect, RedirectProps } from "react-router-dom"

export const CustomRedirect = (props: RedirectProps) => {
	const commonData = {
		search: window.location.search,
		state: { isRedirect: true }
	}
	return (
		<Redirect
			{...props}
			to={
				typeof props.to === "object"
					? { ...props.to, ...commonData }
					: { pathname: props.to, ...commonData }
			}
		/>
	)
}